import debounce from 'lodash.debounce';

import Base from '../base';

const CHECK_TIMEOUT = 100;

class InputValidation extends Base {
	constructor(el) {
		super(el);

		this.checkValidity = debounce(this.checkValidity, CHECK_TIMEOUT);

		this.on('blur');
		this.on('input');
	}

	set isValid(valid) {
		this.el.classList.toggle('is-valid', valid);
		this.el.classList.toggle('is-invalid', !valid);
	}

	onBlur(e) {
		this.el.classList.add('is-changed');

		this.checkValidity(e.target);
	}

	onInput(e) {
		this.checkValidity(e.target);
	}

	checkValidity(target) {
		this.isValid = target.checkValidity();
	}
}

export default InputValidation;
